export default "__VITE_ASSET__B7m9mCsc__"